import React from 'react';
import { Badge } from './ui/badge';
import { ReferenceCard } from './ReferenceCard';

export const NoteContentRenderer = ({ content, references = [], showCards = false }) => {

  if (!content) return null;

  // Parse content and replace mentions with clickable links or cards
  const renderContent = () => {
    const parts = [];
    let lastIndex = 0;
    
    // Find all @mentions and #J/#C references in content
    const mentionRegex = /@([^\s]+)|#([JC])([^\s]+)/g;
    let match;
    
    while ((match = mentionRegex.exec(content)) !== null) {
      const fullMatch = match[0]; // e.g., "@John Doe", "#JJob-123", "#CJohn Smith"
      const matchIndex = match.index;
      
      let trigger, matchText;
      if (match[0].startsWith('@')) {
        trigger = '@';
        matchText = match[1]; // "John Doe"
      } else {
        trigger = match[2]; // "J" or "C"
        matchText = match[3]; // "Job-123" or "John Smith"
      }
      
      // Add text before the mention
      if (matchIndex > lastIndex) {
        parts.push(
          <span key={`text-${lastIndex}`}>
            {content.substring(lastIndex, matchIndex)}
          </span>
        );
      }
      
      // Find corresponding reference
      const reference = references.find(ref => {
        const refNameNormalized = ref.name.replace(/\s+/g, ' ').trim();
        const matchTextNormalized = matchText.replace(/\s+/g, ' ').trim();
        return refNameNormalized === matchTextNormalized || 
               ref.name.includes(matchTextNormalized) ||
               matchTextNormalized.includes(ref.name);
      });
      
      if (reference && (trigger === 'J' || trigger === 'C')) {
        // Render as card or compact badge based on showCards prop
        if (showCards) {
          parts.push(
            <div key={`card-${matchIndex}`} className="my-2">
              <ReferenceCard reference={reference} compact={false} />
            </div>
          );
        } else {
          parts.push(
            <span key={`badge-${matchIndex}`} className="inline-block">
              <ReferenceCard reference={reference} compact={true} />
            </span>
          );
        }
      } else if (trigger === '@') {
        // Render @mentions as plain text badges (not clickable)
        parts.push(
          <Badge
            key={`mention-${matchIndex}`}
            variant="secondary"
            className="mx-1 inline-flex"
          >
            {fullMatch}
          </Badge>
        );
      } else {
        // If no reference found, render as plain text
        parts.push(
          <span key={`plain-${matchIndex}`}>{fullMatch}</span>
        );
      }
      
      lastIndex = matchIndex + fullMatch.length;
    }
    
    // Add remaining text
    if (lastIndex < content.length) {
      parts.push(
        <span key={`text-${lastIndex}`}>
          {content.substring(lastIndex)}
        </span>
      );
    }
    
    return parts.length > 0 ? parts : content;
  };

  return (
    <div className="whitespace-pre-wrap break-words">
      {renderContent()}
    </div>
  );
};
